import React from 'react';
import { createRoot } from 'react-dom/client';
import CaseComponent from './components/ImageRemoverWrapper.jsx';

const App = () => {
  return (
    <div>
        <CaseComponent/>
    </div>
  )
};

// react17
// import ReactDOM from 'react-dom';
// ReactDOM.render(<App />, document.getElementById('app'));

// react18
const root = createRoot(document.getElementById('app')); 
root.render(<App/>);

